import React, { useState } from 'react';

import { Badge } from 'antd';

import styled from 'styled-components';

import { useUserPermission } from '@contexts/UserContext';

import useNwBreakPoints from '@hooks/Layout/UseNwBreakPoints';

import NwIcon from '@components/Gui/NwIcon';
import LegalDrawer from '@components/Legal/LegalDrawer';
import PermissionBlock from '@components/PermissionBlock/PermissionBlock';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ContactLegalContainer = styled.p`
    text-transform: uppercase;
    margin-bottom: 0;
`;

const ExpiringDocuments = styled.span`
    display: block;
    margin-top: 0.2rem;
    color: ${(props) => props.theme.DangerColor};
    font-size: ${(props) => props.theme.FontSizeSm};
    line-height: 1.2;
    text-transform: none;
`;

const ContactDetailsHeaderLegal = ({ currentContact, readOnly, mobileFullRow }) => {
    const [drawer, setDrawer] = useState(false);
    const permissionType = `View${currentContact.SubType < 4 ? 'Customer' : 'Model'}Legals`;
    const viewContactLegals = useUserPermission(
        permissionType,
        currentContact && currentContact.Users.map((user) => user.UserID)
    );
    const breakpoints = useNwBreakPoints();

    const handleOpenDrawer = () => {
        if (viewContactLegals) {
            setDrawer(true);
        }
    };

    const renderModelLegalContainer = () => {
        return currentContact.LegalsCount ? (
            <ContactLegalContainer onClick={mobileFullRow ? undefined : handleOpenDrawer}>
                {breakpoints !== 1 && (
                    <>
                        {currentContact.ExpiringLegalsCount > 0 ? (
                            <Badge count={currentContact.LegalsCount} dot>
                                <NwIcon icon={byPrefixAndName.fasl['passport']} />
                            </Badge>
                        ) : (
                            <NwIcon icon={byPrefixAndName.fasl['passport']} />
                        )}
                        &nbsp;&nbsp;
                    </>
                )}
                {currentContact.LegalsCount} {currentContact.LegalsCount > 1 ? 'documents' : 'document'}
                {breakpoints === 1 && currentContact.ExpiringLegalsCount > 0 && (
                    <ExpiringDocuments>
                        {currentContact.ExpiringLegalsCount}{' '}
                        {currentContact.ExpiringLegalsCount > 1 ? 'documents expiring' : 'document expiring'}
                    </ExpiringDocuments>
                )}
            </ContactLegalContainer>
        ) : (
            <ContactLegalContainer
                viewModelLegals={viewContactLegals}
                onClick={mobileFullRow ? undefined : handleOpenDrawer}
            >
                <NwIcon icon={byPrefixAndName.fasl['passport']} danger />
                &nbsp;&nbsp;no documents
            </ContactLegalContainer>
        );
    };

    return (
        <>
            {currentContact && (
                <div
                    className={`header-body-boxes header-body-boxes-hoverable${mobileFullRow ? ' mobile-full-row-trigger' : ''}`}
                    onClick={mobileFullRow ? handleOpenDrawer : undefined}
                >
                    <PermissionBlock permission={viewContactLegals} content={renderModelLegalContainer()} />
                </div>
            )}
            {drawer && (
                <LegalDrawer selectedContact={currentContact.ID} readOnly={readOnly} onClose={() => setDrawer(false)} />
            )}
        </>
    );
};

export default ContactDetailsHeaderLegal;
